import React from 'react';
import './DriverCompanyReference.scss';
import moment from 'moment';

interface DriverCompanyReferenceItemProps {
    id: number;
    companyName: string;
    updatedDate: string;
    updatedBy: string;
}

const DriverCompanyReferenceItem = ({
    id,
    companyName,
    updatedDate,
    updatedBy,
}: DriverCompanyReferenceItemProps): React.ReactElement => {
    return (
        <div className="DriverCompany-Info-Row justify-content-start">
            <div className="DriverCompany-Info-Row justify-content-start">{companyName}</div>
            <div className="DriverCompany-Info-Row justify-content-start">
                {moment(updatedDate).format('YYYY-MM-DD')}
            </div>
            <div className="DriverCompany-Info-Row justify-content-start">{updatedBy}</div>
        </div>
    );
};

export default DriverCompanyReferenceItem;
